const rwPopup = document.querySelector('[data-rw]');
const rwButtons = document.querySelectorAll('.home-hero .hero-overlay .cmeleon-content-buttons > a, [data-rw-button], .home-crosslinks .cmeleon-region-crosslinks > .cmeleon-block-content:nth-child(2) .cmeleon-content-buttons > a');
const rwCloseBtn = document.querySelector('[data-rw-toggle]');
const rwNavBtnPrev = document.querySelectorAll('[data-rw-panel-nav-btn-prev]');
const rwNavBtnNext = document.querySelectorAll('[data-rw-panel-nav-btn-next]');
const formEl = document.getElementById('reservation-request');
const locationMail = document.querySelector('[data-location-mail]');
const blockedDates = [
  '1-1', // Nieuwjaarsdag
  '4-9', // Eerste paasdag
  '4-10', // Tweede paasdag
  '4-27', // Koningsdag
  '5-18', // Hemelvaart
  '5-28', // Eerste pinksterdag
  '5-29', // Tweede pinksterdag
  '12-25', // Eerste kerstdag
  '12-26', // Tweede kerstdag
];

export function switchPanel(panelIndex) {
    const rwPanels = document.querySelectorAll('.rw-panel');
    const rwNextPanel = document.querySelector(`[data-rw-panel${panelIndex}]`);
    const currentPanel = document.querySelector(`[data-rw-panel${panelIndex-1}]`);

    // Fill location e-mail in time panel based on selected location
    if (currentPanel && currentPanel.querySelector('[data-rw-input-location]')) {
      locationMail.innerHTML = document.querySelector('[data-rw-input-location]').value;
    }

    // Validate date
    if(currentPanel && currentPanel.querySelector('[data-rw-input-date]')) {
        const dateValue = currentPanel.querySelector('[data-rw-input-date]').value;
        if (dateValue === '') {
          alert('Datum is verplicht');
          return;
        }

        let dateValueParsed = new Date(dateValue);
        dateValueParsed = (dateValueParsed.getMonth()+1) + '-' + dateValueParsed.getDate();
        if (blockedDates.includes(dateValueParsed)) {
          alert('Deze datum betreft een feestdag. U kunt geen reservering plaatsen voor deze datum. Kies een andere datum.');
          return;
        }
    }

    // Validate time
    if(currentPanel && currentPanel.querySelector('[data-rw-input-time]')) {
      const timeValue = currentPanel.querySelector('[data-rw-input-time]').value;
      if (timeValue === '') {
        alert('Tijd is verplicht');
        return;
      }
    }

    rwPanels.forEach((element) => {
        element.classList.add('hidden');
    });

    rwNextPanel.classList.remove('hidden');
}

export function getNodeindex(elm) {
    const c = elm.parentNode.children;
    let i = c.length;

    while (i--) if (c[i] == elm) return i;
}

export default function initReservationWizard() {
    // Show and hide buttons
    if (rwButtons) {
        rwButtons.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();

                rwPopup.classList.remove('hidden');
                rwPopup.classList.remove('lg:hidden');
            });
        });
    }

    if (rwCloseBtn) {
        rwCloseBtn.addEventListener('click', (e) => {
            rwPopup.classList.add('hidden');
            rwPopup.classList.add('lg:hidden');
        });
    }

    // Dynamically create eventhandler for each step
    const stepFields = ['location', 'date', 'time', 'arrangement', 'activity'];
    for (let i = 0; i < stepFields.length; i++) {
        const rwInput = document.querySelector(`[data-rw-input-${stepFields[i]}]`);
        const rwValueHolder = document.querySelector(`[data-rw-holder-${stepFields[i]}]`);

        // Set values to sidebar when they are filled
        if (rwInput) {
            rwInput.addEventListener('change', (e) => {
                if (stepFields[i] !== 'date') {
                    if (stepFields[i] == 'location') {
                      rwValueHolder.innerHTML = `<div class="rw-step-value-triangle"></div>${e.target.options[e.target.selectedIndex].text}`;
                    } else if (e.target.value) {
                      rwValueHolder.innerHTML = `<div class="rw-step-value-triangle"></div>${e.target.value}`;
                    }else{
                      rwValueHolder.innerHTML = ``;
                    }
                } else {
                    rwValueHolder.innerHTML = `<div class="rw-step-value-triangle"></div>${new Date(e.target.value).toLocaleDateString('nl-NL', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                    })}`;
                }

                rwValueHolder.parentElement.classList.add('filled');

                // When value has been set or changed, open the next panel
                if (stepFields[i] !== 'arrangement' && stepFields[i] !== 'activity') {
                    switchPanel((i + 2));
                }
            });
        }
    }

    // Jump to step when clicking on one in sidebar
    const rwSteps = document.querySelectorAll('.rw-steps > li > .rw-step-label');
    rwSteps.forEach((element) => {
        element.addEventListener('click', (e) => {
            const nodeIndex = getNodeindex(e.target.parentNode);
            switchPanel((nodeIndex + 1));
        });
    });

    // Confirm button to jump to the last step
    const rwToConfirm = document.querySelector('[data-rw-button-to-confirm]');
    if (rwToConfirm) {
        rwToConfirm.addEventListener('click', (e) => {
            switchPanel(5);
        });
    }

    // Nav buttons (prev / next panel)
    if (rwNavBtnPrev && rwNavBtnNext) {
        rwNavBtnPrev.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();

                const nodeIndex = getNodeindex(e.target.parentNode.parentNode);
                switchPanel(nodeIndex);
            });
        });

        rwNavBtnNext.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();

                const nodeIndex = getNodeindex(e.target.parentNode.parentNode);
                switchPanel((nodeIndex + 2));
            });
        });
    }

    // Form submit validation for last panel
    // Note: the Laravel way requires opening the popup and active panel again
    if (formEl) {
        formEl.addEventListener('submit', (e) => {
            e.preventDefault();

            let formValid = true;
            const rwConfirmInputs = document.querySelectorAll('#reservation-request-name, #reservation-request-email, #reservation-request-phone');
            const validateEmail = (email) => email.match(
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            );

            rwConfirmInputs.forEach((element) => {
                if ((element.getAttribute('name') === 'email' && (element.value === '' || !validateEmail(element.value))) || element.value === '') {
                    element.classList.add('not-valid');
                    element.setAttribute('placeholder', 'Dit veld is verplicht');
                    formValid = false;
                } else {
                    element.classList.remove('not-valid');
                }
            });

            if (formValid) {
                formEl.submit();
            }
        });
    }
}
